export default {"src":"/_next/static/media/PTON.944fbb24.svg","height":18,"width":18};